<template>
    <div class="container-fluid">
        <!-- home -->
        <div class="row bg-nvidia section-global-small">
            <div class="static-pages">
                <div class="static-pages-title">
                    <div class="container">
                        <div class="content-holder end">
                            <div class="col-xs-12 col-lg-6 p-a-0">
                                <div class="text-wrapper-mid">
                                    <h1 class="text-white text-upper text-nvdia-green">Coming Soon!</h1>
                                    <h3 class="text-white m-t">
                                        Sign up to be notified for coming builds featuring
                                        NVIDIA® GeForce RTX™ series graphic cards.
                                    </h3>
                                    <div class="klaviyo-form-J2QZNf"></div>
                                    <div class="m-t-md">
                                        <img src="/images/section-images/nvidia-landing/nvidia-tag.png" alt="">
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /.home -->
        <!-- section2 -->
        <div class="row bg-black section-global-small">
            <div class="static-pages">
                <div class="static-pages-title">
                    <div class="container">
                        <div class="content-holder between wrap-normal">
                            <div class="col-xs-12 col-lg-6 p-a-0">
                                <div class="intro-image no-response">
                                    <img src="/images/section-images/nvidia-landing/nvidia-turing-build.png" alt="" class="img-response-w">
                                </div>
                            </div>
                            <div class="col-xs-12 col-lg-6 p-a-0">
                                <div class="text-wrapper">
                                    <h1 class="text-white text-upper">nvidia turing</h1>
                                    <h3 class="text-white m-t">
                                        GeForce® RTX graphics cards are powered by the Turing GPU architecture and the all-new
                                        RTX platform. This gives you up to 6X the performance of previous-generation graphics
                                        cards and brings the power of real-time ray tracing and AI to games.
                                    </h3>

                                    <div class="feature-desc-container m-t">
                                        <div class="desc m-t">
                                            <p class="text-white text-upper">up to</p>
                                            <h3 class="text-white text-upper">6x</h3>
                                            <p class="text-white text-upper">faster performance</p>
                                        </div>
                                        <div class="desc m-t">
                                            <p class="text-white text-upper">real-time</p>
                                            <h3 class="text-white text-upper">ray tracing</h3>
                                            <p class="text-white text-upper">in games</p>
                                        </div>
                                        <div class="desc m-t">
                                            <p class="text-white text-upper">POWERFUL</p>
                                            <h3 class="text-white text-upper">ai</h3>
                                            <p class="text-white text-upper">enhanced graphics</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /.section2 -->
        <div class="row service-package" id="home-service">
            <div class="bld-features col-xs-12 p-a-0 m-y">
                <div class="service-details col-xs-12 col-md-3 text-center m-y">
                    <div class="img-container">
                        <img src="images/icons/build-ico.png" alt="" class="m-auto">
                    </div>
                    <div class="content">
                        <div class="text-white text-upper">
                            <h3 class="text-bold">TAILORED FOR<br>GAMES </h3>
                        </div>
                        <div class="text text-white">
                            <p class="text-bold">We’ve done the research and our algorithm takes care of the rest.</p>
                        </div>
                    </div>
                    <router-link to="/what-is-bld" class="link-btn link-white">
                        LEARN MORE
                        <i class="fa fa-chevron-right" aria-hidden="true" />
                    </router-link>
                </div>
                <div class="service-details col-xs-12 col-md-3 text-center m-y">
                    <div class="img-container">
                        <img src="images/icons/glass.png" alt="" class="m-auto">
                    </div>
                    <div class="content">
                        <div class="text-white text-upper">
                            <h3 class="text-bold">TRANSPARENT<br>PRICING</h3>
                        </div>
                        <div class="text text-white">
                            <p class="text-bold">
                                Customize your build with our curated parts with straight forward pricing and a flat $99 assembly fee.
                            </p>
                        </div>
                    </div>
                    <router-link to="/what-is-bld" class="link-btn link-white">
                        LEARN MORE
                        <i class="fa fa-chevron-right" aria-hidden="true" />
                    </router-link>
                </div>
                <div class="service-details col-xs-12 col-md-3 text-center m-y">
                    <div class="img-container">
                        <img src="images/icons/2year-ico.png" alt="" class="m-auto">
                    </div>
                    <div class="content">
                        <div class="text-white text-upper">
                            <h3 class="text-bold">All-in-One<br>Warranty</h3>
                        </div>
                        <div class="text text-white">
                            <p class="text-bold">All components under one warranty plan – NZXT will manage any problems for you. </p>
                        </div>
                    </div>
                    <router-link to="/what-is-bld" class="link-btn link-white">
                        LEARN MORE
                        <i class="fa fa-chevron-right" aria-hidden="true" />
                    </router-link>
                </div>
                <div class="service-details col-xs-12 col-md-3 text-center m-y">
                    <div class="img-container">
                        <img src="images/icons/shipping-ico.png" alt="" class="m-auto">
                    </div>
                    <div class="content">
                        <div class="text-white text-upper">
                            <h3 class="text-bold">48-Hour<br>Turnaround</h3>
                        </div>
                        <div class="text text-white">
                            <p class="text-bold">Get in the game quickly.</p>
                        </div>
                    </div>
                    <router-link to="/what-is-bld" class="link-btn link-white">
                        LEARN MORE <i class="fa fa-chevron-right" aria-hidden="true" />
                    </router-link>
                </div>
            </div>
        </div>
        <!-- bld-intro-text -->
        <div class="row pos-r bg-black" id="what-is-bld">
            <a href="http://nzxt.com/" class="home-card bg-deep-purple bg-nzxt-section col-xs-12 col-md-6 p-a-0 pos-r" target="_blank">
                <div class="section-content-holder p-y-md p-x m-auto text-white front">
                    <div class="content-title-holder">
                        <h2 class="text-upper">Cases, cooling &amp; accesories</h2>
                        <a href="http://nzxt.com/" class="link-btn link-white" target="_blank">
                            LEARN MORE
                            <i class="fa fa-chevron-right" />
                        </a>
                    </div>
                    <img src="/images/brand-logos/nzxt-bg-logo-w.png" alt="">
                    <div class="clearfix"></div>
                </div>
                <div class="overlay-linear"></div>
            </a>
            <a href="https://camwebapp.com/" class="home-card bg-blue bg-cam-section col-xs-12 col-md-6 p-a-0 pos-r" target="_blank">
                <div class="section-content-holder p-y-md p-x m-auto text-white front">
                    <div class="content-title-holder">
                        <h2 class="text-upper">Free app to monitor your PC</h2>
                        <a href="https://camwebapp.com/" class="link-btn link-white" target="_blank">
                            DOWNLOAD NOW
                            <i class="fa fa-chevron-right"></i>
                        </a>
                    </div>
                    <img src="/images/brand-logos/cam-by-nzxt.png" alt="">
                    <div class="clearfix"></div>
                </div>
                <div class="overlay-radial"></div>
            </a>
        </div>
    </div>
</template>


<script>
export default {
  name: "index",
  data() {
    return {
      slickConfig: {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplaySpeed: 4000,
        responsive: [
          {
            breakpoint: 1366,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true
            }
          },
          {
            breakpoint: 770,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ]
      }
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      $("body").scrollspy({
        target: "#navbar-spy"
      });
      $(".media-quotes").slick(this.slickConfig);
      $(".bld-features").slick(
        Object.assign(this.slickConfig, {
          dots: true
        })
      );
      $(".quality-extra").slick(
        Object.assign(this.slickConfig, {
          autoplaySpeed: 6000
        })
      );
    }
  }
};
</script>

